var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_145_49)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_145_49",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_145_49",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_145_49",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACe0lEQVR4nO3dwYoTQRSF4asLR8EXUN9wHF3qMjsFIQyNgdwDgeyzdCE+gY6LcXwJQXClUcRVSWGDIoyi6ap7quv8cJcZuj+K7iTd6TFTSimllFJKqTk0DMMRgPsAztz9M4DUwviPbT0DcLLb7a4Zc+v1+g6At9FoOBz9Iu+LEa/k5pHxc95QruzxcBGNkyZe2XeNLQCvZwj9ytgCsI+GwfSzN7YIUFKJMbaiQSDotsfYigaBoNseYysaBIJue4ytaBAIuu0xtqJBIOi2x9iKBoGg2x5jKxoEgm57jK2eoZfL5Q0AGC/wfgDwJF/aEzSmhc7Iv7/O3Z8Xwe4VOqV05bKrS0Wwe17R7v7pstdPjt0zNIDTP/2NSbF7hh6G4ShjVsHuGTqXb7YB8Owv2C+22+11O6TeoathR4OAALoKdjQISKCLY0eDgAi6KHY0CMigi2HX3Hl3/wbgwWazuX0IBMt+/dNbv8rQD0sDB+zXY7YNSgBuFReuvF/u/p5qgwCkGoeM2vvl7u+oNggzPXS4+yOqDcJ4MszYOhnOaKznt3doAFofWFAeWh/BUR5aXyqhPLS+JkV5aH3xj/LQupSFOtDu/rQKcs/Qi8XiKoAvVZB7h3b3r1WQe4bOufu2CnKuZ+jVanUzY48rO98edqqbHDE99K/34VnpokFAAF2laBAIuu0xtqJBIOi2x9iKBoGg2x5jKxoEgm57jK1oEAi67TG2okEg6LbH2IoGQUfQc3wI7Edja3xse5rZvDS23P0eAUyaeI6NrfHehgsCnDTRnFM+ej6X/wHBTLDPa/6q4L8ab406yce3xk6Q+3Gbj2lXslJKKaWUUkpZUN8BLcyeifTamgsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.bf0595436316e38c04e4fcd3a653836a.svg";
export { ForwardRef as ReactComponent };